import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a16b41a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"layer base\" data-v-5a16b41a></div><div class=\"depthWrap dRayA\" data-v-5a16b41a><div class=\"ray rayA\" data-v-5a16b41a></div></div><div class=\"depthWrap dRayB\" data-v-5a16b41a><div class=\"ray rayB\" data-v-5a16b41a></div></div><div class=\"depthWrap dBloom\" data-v-5a16b41a><div class=\"layer bloom\" data-v-5a16b41a></div></div>", 4)
const _hoisted_5 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["gradientBg", [_ctx.variant, 'motion-'+_ctx.motion, {'animated': _ctx.animated, 'depth': _ctx.depth}]]),
    "aria-hidden": "true"
  }, _hoisted_5, 2))
}